/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BasicCostGroupType {
  Task = 'task',
  Budget = 'budget',
  CostType = 'costType'
}
